import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { menuInfo } from "@shared/type/CommonType";
import { global } from "@shared/libs/Global";
import { getInitFormData } from "@shared/utils/CommonUtils";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import SnResizableLNR from "@shared/components/SnResizableLNR";
import { List } from "@mui/material";
import SnButton from "@shared/components/SnButton";
import { showIssueModal } from "@widgets/IssueModal";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { SnGridRef } from "@shared/components/GridV2/SnGridTypes";

interface Props {
  Menuprops: menuInfo;
}

const SN_SFA_ISSUE_REP_003 = forwardRef(({ Menuprops }: Props, ref) => {
  const searchRef = useRef<any>(null);
  const { userInfo } = global();
  const gridRefs = useRef<{ [key: string]: React.RefObject<SnGridRef> }>({
    grid1: React.createRef<SnGridRef>(),
  });

  const getGridCurrent = (key: string): SnGridRef => {
    const grid = gridRefs.current[key]?.current;
    if (!grid) {
      throw new Error(`Grid '${key}' is not mounted yet`);
    }
    return grid;
  };
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
  });

  //#region grid 높이 관련
  let width1 = "49.5%";
  let width2 = "49.5%";
  const menuSize = localStorage.getItem("menuSize");
  if (menuSize) {
    const menu = JSON.parse(menuSize);
    if (menu.SN_SFA_ISSUE_REP_003) {
      width1 = menu.SN_SFA_ISSUE_REP_003.grid1Width
        ? menu.SN_SFA_ISSUE_REP_003.grid1Width
        : width1;
      width2 = menu.SN_SFA_ISSUE_REP_003.grid2Width
        ? menu.SN_SFA_ISSUE_REP_003.grid2Width
        : width2;
    }
  }

  const [grid1Width, setGrid1Width] = useState<string | number>(width1);
  const [grid2Width, setGrid2Width] = useState<string | number>(width2);

  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormControlData(rtn.formControlData);
        setFormData(rtn.formData);
        setColums({ grid1: rtn.grid.grid1 });
      } catch (error) {}
    };
    fetchform();
  }, [userInfo]);

  useEffect(() => {
    if (formData) {
      onSearch(true);
    }
  }, [formData]);

  useImperativeHandle(ref, () => ({
    onSearch,
  }));

  const onSearch = async (isInit?: boolean) => {
    try {
      const Param = {
        cd_firm: "",
        cd_emp: "",
        dc_reference: "",
        cd_cust: "",
        yn_tm_confirm: "",
        dt_from: "",
        dt_to: "",
        yn_tm_done: "",
        dt_from_done: "",
        dt_to_done: "",
        str_search: "",
        yn_open: "",
        yn_assign: "",
        yn_solving: "",
        yn_done: "",
        yn_test: "",
        yn_confirm: "",
        yn_cancel: "",
      };

      // 3. 조회 요청
      const params1 = {
        id: "sn_sfa_issue_rep_003_03",
        params: Param,
      };
      const empData: any = await fnGetDataSet(params1);
    } catch (error: any) {}
  };

  const handleDoubleClick = async (issue: any) => {};

  const onResizeStopH = (width: number) => {
    setGrid1Width(width);
  };

  const onResizeStopL = (width: any) => {
    setGrid2Width(width);
  };

  //#region useMemo
  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
      },
    }),
    [columns, dataSources]
  );
  //#endregion

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}

        ></SearchPanel>
      </div>

      <div className="w-full flex flex-row space-x-2 flex-grow overflow-x-auto">
        <SnGrid
          ref={gridRefs.current["grid1"]} // Grid Name
          columnConfig={grids.grid1.columns} // 컬럼 설정 전달
          rowData={grids.grid1.dataSource} // Datasource
          etcProps={{
            rowSelection: "single",
            title: "이슈정보",
            isEditable: true,
          }}
        />
      </div>
    </div>
  );
});

export default SN_SFA_ISSUE_REP_003;
